export const ALL_ORDERS_QUERY = `
  query GetAllOrders($first: Int, $page: Int, $track_code: String, $date_from: String, $date_to: String) {
    allOrders(first: $first, page: $page, track_code: $track_code, date_from: $date_from, date_to: $date_to) {
      data {
        id
        track_code
        status
        total
        branch {
          id
          name
          address
        }
        created_at
        updated_at
      }
      pagination {
        current_page
        last_page
        per_page
        total
        has_more_pages
      }
    }
  }
`;

export const ORDER_ITEMS_QUERY = `
  query GetOrderItems($orderId: String!, $first: Int, $page: Int) {
    orderItems(order_id: $orderId, first: $first, page: $page) {
      data {
        id
        product_id
        variant_id
        quantity
        qty
        price
        subtotal
        product {
          id
          name
          slug
          main_image_url
        }
        productVariant {
          id
          name
          sku
        }
      }
      pagination {
        current_page
        last_page
        per_page
        total
        has_more_pages
      }
    }
  }
`;

